/* =========================================================
   Vitavien Şube Paneli — panel.v9.js
   - panel.v8.js'in Cloudflare Workers + D1 backend'ine portu (2026-05-14)
   - api() fonksiyonu Workers REST endpoint'lerine yönlenir
   - Yeni sekme: Menü Yönetimi (146 ürün tablo + inline edit + sync_now)
   - Apps Script paralel devam eder; cutover sonrası Hakan trigger'ları kapatır.
   ========================================================= */
(function () {
  'use strict';

  const CFG = window.VITAVIEN_PANEL || {};
  const WORKERS_URL = (CFG.WORKERS_URL || '').replace(/\/+$/, '');
  if (!WORKERS_URL) {
    console.warn('[Vitavien Panel] WORKERS_URL boş.');
  }

  const COOKIE_NAME = 'vitavien_panel_auth';
  const COOKIE_DAYS = 30;
  const LS_KEY = 'vitavien_panel_auth';
  const LS_EXPIRY_KEY = 'vitavien_panel_auth_exp';

  // Reports cache config
  const REPORTS_CACHE_PREFIX = 'vita_rep_cache_';
  const REPORTS_CACHE_TTL_MS = 5 * 60 * 1000; // 5 dakika

  // === Helpers ===

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function setCookie(name, value, days) {
    try {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax${secure}`;
    } catch (_) {}
    try {
      const exp = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(LS_KEY, value);
      localStorage.setItem(LS_EXPIRY_KEY, String(exp));
    } catch (_) {}
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (m) return decodeURIComponent(m[2]);
    try {
      const v = localStorage.getItem(LS_KEY);
      const exp = parseInt(localStorage.getItem(LS_EXPIRY_KEY) || '0', 10);
      if (v && exp && Date.now() < exp) {
        try {
          const d = new Date(exp);
          const secure = location.protocol === 'https:' ? '; Secure' : '';
          document.cookie = `${name}=${encodeURIComponent(v)}; expires=${d.toUTCString()}; path=/; SameSite=Lax${secure}`;
        } catch (_) {}
        return v;
      }
    } catch (_) {}
    return null;
  }

  function deleteCookie(name) {
    try { document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`; } catch (_) {}
    try { localStorage.removeItem(LS_KEY); localStorage.removeItem(LS_EXPIRY_KEY); } catch (_) {}
  }

  async function sha256Hex(str) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  function fmtMoney(n) {
    return Math.round(Number(n) || 0).toLocaleString('tr-TR');
  }

  function fmtTimer(sec) {
    sec = Math.max(0, Math.floor(sec));
    const h = String(Math.floor(sec / 3600)).padStart(2, '0');
    const m = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  }

  function fmtClock(d) {
    const days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    return `${h}:${m} · ${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}`;
  }

  // Servis dönemi otomatik tespiti
  function detectShift(d) {
    const h = d.getHours();
    if (h >= 5 && h < 11) return 'Sabah servisi';
    if (h >= 11 && h < 15) return 'Öğle servisi';
    if (h >= 15 && h < 18) return 'İkindi servisi';
    if (h >= 18 && h < 23) return 'Akşam servisi';
    return 'Gece servisi';
  }

  function parseClopossDate(s) {
    if (!s) return null;
    if (s instanceof Date) return s;
    const str = String(s).trim();
    if (str.includes('T')) return new Date(str);
    return new Date(str.replace(' ', 'T') + '+03:00');
  }

  function statusFromOpened(openedAt) {
    if (!openedAt) return 'fresh';
    const now = Date.now();
    const elapsedMin = (now - openedAt.getTime()) / 60000;
    if (elapsedMin > 75) return 'late';
    if (elapsedMin > 30) return 'warm';
    return 'fresh';
  }

  function statusLabel(status) {
    if (status === 'late') return 'Geç';
    if (status === 'warm') return 'Ilık';
    return 'Taze';
  }

  function relativeTime(d) {
    if (!d) return '';
    const sec = Math.floor((Date.now() - d.getTime()) / 1000);
    if (sec < 60) return 'şimdi';
    const m = Math.floor(sec / 60);
    if (m < 60) return `${m} dk önce`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h} sa önce`;
    return `${Math.floor(h / 24)} g önce`;
  }

  // BUG 2 FIX: Local-aware YYYY-MM-DD formatter.
  // ÖNCEDEN: toISOString().slice(0,10) → İST 00:00 = UTC önceki gün 21:00 → "bir gün geri" bugu.
  // ŞİMDİ: getFullYear/getMonth+1/getDate yerel saat üzerinden manuel format.
  function fmtLocalISODate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  }

  // Tarih farkı (gün) — TR locale göreceli ifade için
  function diffDaysHuman(fromISO, toISO) {
    const f = new Date(fromISO + 'T00:00:00');
    const t = new Date(toISO + 'T00:00:00');
    const days = Math.round((t - f) / (24 * 60 * 60 * 1000)) + 1;
    if (days === 1) return '1 gün';
    if (days < 7) return `${days} gün`;
    if (days === 7) return '7 gün';
    if (days <= 14) return `${days} gün`;
    if (days === 30) return '30 gün';
    return `${days} gün`;
  }

  // === API (Workers REST) ===
  // Action → REST endpoint mapping. panel.v8.js'in api(action, params) çağrı sözleşmesi korunuyor.
  // Auth: localStorage'daki PANEL_TOKEN (sha256(şifre)) X-Panel-Token header'ına gider.
  // Workers her endpoint'i `{ ok:true, data:{...} }` formatında döndürür — panel.v8 ile uyumlu.

  const ACTION_MAP = {
    summary: { method: 'GET', path: '/summary' },
    tables: { method: 'GET', path: '/tables' },
    tables_live: { method: 'GET', path: '/tables' },
    receipt: { method: 'GET', path: '/receipt' },
    reports: { method: 'GET', path: '/reports' },
    logs: { method: 'GET', path: '/logs' },
    feedback_submit: { method: 'POST', path: '/feedback_submit', noAuth: true },
    call_waiter: { method: 'POST', path: '/call_waiter', noAuth: true },
    products_list: { method: 'GET', path: '/products' },
    products_patch: { method: 'PATCH', path: '/products' }, // path + /:id caller'da
    products_sync_now: { method: 'POST', path: '/products/sync_now' },
    force_menu_sync: { method: 'POST', path: '/products/sync_now' },
    custom_fields_list: { method: 'GET', path: '/custom_fields' },
    custom_fields_patch: { method: 'PATCH', path: '/custom_fields' },
  };

  async function api(action, params, opts) {
    opts = opts || {};
    const cfg = ACTION_MAP[action];
    if (!cfg) throw new Error('Bilinmeyen action: ' + action);
    const token = getCookie(COOKIE_NAME) || '';

    let path = cfg.path;
    if (opts.subPath) path += opts.subPath;

    let url = WORKERS_URL + path;
    const reqInit = {
      method: cfg.method,
      headers: {}
    };
    if (!cfg.noAuth) {
      reqInit.headers['X-Panel-Token'] = token;
    }

    const usp = new URLSearchParams();
    if (params) {
      for (const k of Object.keys(params)) {
        if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
          usp.append(k, String(params[k]));
        }
      }
    }

    if (cfg.method === 'GET') {
      if (usp.toString()) url += '?' + usp.toString();
    } else {
      // POST/PATCH: body JSON, branch query string'de
      if (params && params.branch) usp.set('branch', params.branch);
      if (usp.toString()) url += '?' + usp.toString();
      if (opts.body !== undefined) {
        reqInit.headers['Content-Type'] = 'application/json';
        reqInit.body = JSON.stringify(opts.body);
      } else if (params) {
        // POST için bazı çağrılar body bekliyor; explicit body verilmezse params'tan al
        reqInit.headers['Content-Type'] = 'application/json';
        reqInit.body = JSON.stringify(params);
      }
    }

    const res = await fetch(url, reqInit);
    if (!res.ok && res.status !== 401 && res.status !== 429) {
      // 401 ve 429 için body okumayı bekle (kontrollü)
      throw new Error('HTTP ' + res.status);
    }
    let data;
    try {
      data = await res.json();
    } catch (e) {
      throw new Error('JSON parse fail (HTTP ' + res.status + ')');
    }
    if (!data.ok) throw new Error(data.error || ('HTTP ' + res.status));
    // Workers payload'ı data.data altında; legacy uyum için flat fallback
    return data.data !== undefined ? data.data : data;
  }

  // === Gate (şifre ekranı) ===

  async function tryUnlock(passwordPlain) {
    const hash = await sha256Hex(passwordPlain);
    setCookie(COOKIE_NAME, hash, COOKIE_DAYS);
    try {
      await api('summary', { branch: 'sisli' });
      return true;
    } catch (e) {
      deleteCookie(COOKIE_NAME);
      return false;
    }
  }

  async function verifyAuthAsync() {
    if (!getCookie(COOKIE_NAME)) return;
    try {
      await api('summary', { branch: state.branch });
    } catch (e) {
      console.warn('[Vitavien Panel] auth verify fail → logout', e);
      deleteCookie(COOKIE_NAME);
      location.reload();
    }
  }

  function showGate() {
    const panel = $('#vita-panel');
    if (panel) panel.dataset.stage = 'locked';
    $('[data-vita-shell]').hidden = true;
    document.body.classList.add('vita-panel-active');
    const pwd = $('[data-vita-pwd]');
    if (pwd) pwd.focus();
  }

  function showShell() {
    const panel = $('#vita-panel');
    if (panel) panel.dataset.stage = 'unlocked';
    $('[data-vita-shell]').hidden = false;
    document.body.classList.add('vita-panel-active');
    startApp();
  }

  // === STATE & RENDER ===

  const state = {
    branch: 'sisli',
    summary: null,
    tables: [],
    pollHandle: null,
    cardTimerHandle: null,
    clockHandle: null,
    sideOpenReceiptId: null,
    reportsLoaded: false,
    reportsCurrentPeriod: '7d',
    reportsCurrentRange: null,
    reportsRequestId: 0,
    chartObserver: null,
    chartsRendered: new Set(),
  };

  function render() {
    renderSummary();
    renderTables();
  }

  function renderSummary() {
    const s = state.summary || {};
    const activeEl = $('[data-sum="active_tables"]');
    if (activeEl) activeEl.textContent = s.activeTables ?? '—';

    const revEl = $('[data-sum="today_revenue"]');
    if (revEl) {
      revEl.innerHTML = `${fmtMoney(s.todayRevenue || 0)}<span class="vita-unit">TL</span>`;
    }

    const billEl = $('[data-sum="avg_bill"]');
    if (billEl) {
      billEl.innerHTML = `${fmtMoney(s.avgBill || 0)}<span class="vita-unit">TL</span>`;
    }

    const durEl = $('[data-sum="avg_duration"]');
    if (durEl) {
      durEl.innerHTML = `${s.avgDurationMin || 0}<span class="vita-unit">dk</span>`;
    }

    const closedToday = s.todayClosedReceipts || 0;
    const activeNow = s.activeTables || 0;
    const activeDeltaEl = $('[data-sum="active_delta"]');
    if (activeDeltaEl) {
      activeDeltaEl.textContent = activeNow > 0 ? `${activeNow} masa aktif` : 'Şu an boş';
    }
    const revDeltaEl = $('[data-sum="revenue_delta"]');
    if (revDeltaEl) {
      revDeltaEl.textContent = closedToday ? `${closedToday} hesap kapandı` : 'Bugün henüz hesap yok';
    }
    const billDeltaEl = $('[data-sum="bill_delta"]');
    if (billDeltaEl) {
      billDeltaEl.textContent = closedToday ? `${closedToday} hesap üzerinden` : '—';
    }
    const durDeltaEl = $('[data-sum="duration_delta"]');
    if (durDeltaEl) {
      const avg = s.avgDurationMin || 0;
      if (!avg) durDeltaEl.textContent = '—';
      else if (avg < 30) durDeltaEl.textContent = 'Hızlı oturum';
      else if (avg < 60) durDeltaEl.textContent = 'Ortalama tempolu';
      else if (avg < 90) durDeltaEl.textContent = 'Sakin oturum';
      else durDeltaEl.textContent = 'Uzun oturum';
    }
  }

  function renderTables() {
    const grid = $('[data-vita-grid]');
    const empty = $('[data-vita-empty]');
    const laneCount = $('[data-vita-lane-count]');

    if (!grid) return;
    grid.classList.remove('vita-loading');

    if (!state.tables || !state.tables.length) {
      grid.innerHTML = '';
      grid.style.display = 'none';
      if (empty) empty.hidden = false;
      if (laneCount) laneCount.textContent = '0 aktif';
      return;
    }

    grid.style.display = '';
    if (empty) empty.hidden = true;
    if (laneCount) laneCount.textContent = `${state.tables.length} aktif`;

    const seen = new Set();
    state.tables.forEach(t => {
      const cardId = `vita-card-${t.receipt_id}`;
      seen.add(cardId);
      let card = grid.querySelector('#' + cardId);
      const status = statusFromOpened(parseClopossDate(t.opened_at));

      if (!card) {
        card = document.createElement('div');
        card.id = cardId;
        card.className = `vita-table-card ${status}`;
        card.dataset.receiptId = t.receipt_id;
        card.addEventListener('click', () => openSidePanel(t.receipt_id));
        grid.appendChild(card);
      } else {
        card.className = `vita-table-card ${status}`;
      }

      const seats = Number(t.guests) || 1;
      const opened = parseClopossDate(t.opened_at);
      const elapsedSec = opened ? Math.floor((Date.now() - opened.getTime()) / 1000) : 0;
      const tableName = (t.table_name || `M-${t.table_id || '?'}`).replace(/^Hall \d+ \/ /, '');
      const zone = (t.hall_name || 'Salon').trim();
      const waiter = (t.open_by_user_name || '').replace(/^Baha /, '');

      card.innerHTML = `
        <div class="vita-card-head">
          <div class="vita-card-id">
            <div class="vita-card-code">${escapeHtml(tableName)}</div>
            <div class="vita-card-zone">${escapeHtml(zone)}</div>
          </div>
          <div class="vita-status-chip">${statusLabel(status)}</div>
        </div>
        <div class="vita-card-mid">
          <span class="vita-card-people">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="8" cy="5" r="2.4"/>
              <path d="M2.5 13.5c1-3 4-3.5 5.5-3.5s4.5.5 5.5 3.5"/>
            </svg>
            ${seats} kişi
          </span>
          <span class="vita-timer" data-elapsed="${elapsedSec}">${fmtTimer(elapsedSec)}</span>
        </div>
        <div class="vita-card-foot">
          <span class="vita-card-bill">${fmtMoney(t.total)}<span class="currency"> TL</span></span>
          <span class="vita-card-waiter">${escapeHtml(waiter)}</span>
        </div>
        ${t.updated_at ? `<div class="vita-card-last">Son hareket ${escapeHtml(relativeTime(parseClopossDate(t.updated_at)))}</div>` : ''}
      `;
    });

    grid.querySelectorAll('.vita-table-card').forEach(c => {
      if (!seen.has(c.id)) {
        c.style.opacity = '0';
        setTimeout(() => c.remove(), 250);
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[ch]);
  }

  function tickCardTimers() {
    document.querySelectorAll('.vita-table-card .vita-timer[data-elapsed]').forEach(el => {
      const e = parseInt(el.dataset.elapsed) + 1;
      el.dataset.elapsed = e;
      el.textContent = fmtTimer(e);
      if (e % 60 === 0) {
        const card = el.closest('.vita-table-card');
        if (card) {
          const minutes = e / 60;
          let newStatus = 'fresh';
          if (minutes > 75) newStatus = 'late';
          else if (minutes > 30) newStatus = 'warm';
          card.classList.remove('fresh', 'warm', 'late');
          card.classList.add(newStatus);
          const chip = card.querySelector('.vita-status-chip');
          if (chip) chip.textContent = statusLabel(newStatus);
        }
      }
    });
  }

  // === SIDE PANEL (detay) ===

  async function openSidePanel(receiptId) {
    const side = $('[data-vita-side]');
    side.hidden = false;
    state.sideOpenReceiptId = receiptId;

    $('[data-side-title]').textContent = 'Yükleniyor…';
    $('[data-side-sub]').textContent = '—';
    $('[data-side-orders]').innerHTML = '<div class="vita-side-loading">Sipariş kalemleri çekiliyor…</div>';

    try {
      const r = await api('receipt', { branch: state.branch, id: receiptId });
      renderSideDetail(r);
    } catch (e) {
      $('[data-side-orders]').innerHTML = `<div class="vita-side-loading">Detay alınamadı: ${escapeHtml(e.message)}</div>`;
    }
  }

  function closeSidePanel() {
    $('[data-vita-side]').hidden = true;
    state.sideOpenReceiptId = null;
  }

  function renderSideDetail(r) {
    const tableName = (r.table_name || `M-${r.table_id || '?'}`).replace(/^Hall \d+ \/ /, '');
    const opened = parseClopossDate(r.opened_at);
    const closed = parseClopossDate(r.closed_at);
    const guests = Number(r.guests) || 0;
    const elapsedSec = opened ? Math.floor(((closed || new Date()).getTime() - opened.getTime()) / 1000) : 0;

    $('[data-side-title]').textContent = `${tableName} · ${r.hall_name || 'Salon'}`;
    const openedTime = opened ? opened.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }) : '—';
    $('[data-side-sub]').textContent = `Açılış ${openedTime} · ${guests} kişi · ${r.open_by_user_name || '—'}`;

    $('[data-side="duration"]').textContent = fmtTimer(elapsedSec);
    $('[data-side="guests"]').textContent = guests;
    $('[data-side="total"]').textContent = `${fmtMoney(r.total)} TL`;
    $('[data-side="waiter"]').textContent = r.open_by_user_name || '—';

    // Orders — Worker `line_items` döndürüyor (Cloudflare migration sonrası shape).
    // Eski Apps Script `items`/`count` alanları artık yok.
    const items = r.line_items || r.items || [];
    if (!items.length) {
      $('[data-side-orders]').innerHTML = `
        <div class="vita-side-orders-empty">
          <div class="vita-empty-mark-mini">—</div>
          <p>Henüz sipariş kalemi yok.<br><small>Kasada işlem yapıldıkça burada görünür.</small></p>
        </div>
      `;
    } else {
      let html = '';
      items.forEach(it => {
        const qty = Number(it.qty != null ? it.qty : it.count) || 0;
        html += `
          <div class="vita-order-line">
            <span class="qty">${qty}×</span>
            <span class="name">${escapeHtml(it.product_name || '')}</span>
            <span class="ttl">${fmtMoney(it.total)} TL</span>
          </div>
        `;
      });
      html += `
        <div class="vita-order-total">
          <span class="label">${closed ? 'Toplam' : 'Şu ana kadar'}</span>
          <span class="amt">${fmtMoney(r.total)} TL</span>
        </div>
      `;
      $('[data-side-orders]').innerHTML = html;
    }

    // Timeline
    const tl = $('[data-side-timeline]');
    if (tl) {
      const rows = [];
      if (opened) rows.push({ time: opened, event: `Masa açıldı · ${r.open_by_user_name || '—'}` });
      if (r.updated_at && r.updated_at !== r.opened_at) {
        const updated = parseClopossDate(r.updated_at);
        if (updated) rows.push({ time: updated, event: 'Son hareket' });
      }
      if (closed) rows.push({ time: closed, event: `Masa kapandı · ${r.close_by_user_name || '—'}` });

      tl.innerHTML = rows.map(row => `
        <div class="vita-timeline-row">
          <span class="time">${row.time.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
          <span class="event">${escapeHtml(row.event)}</span>
        </div>
      `).join('') || '<div class="vita-side-loading">—</div>';
    }
  }

  // === POLLING ===

  async function pollOnce() {
    try {
      const [summary, tables] = await Promise.all([
        api('summary', { branch: state.branch }),
        api('tables_live', { branch: state.branch })
      ]);
      state.summary = summary;
      state.tables = tables;
      render();
    } catch (e) {
      console.error('[Vitavien Panel] poll fail', e);
    }
  }

  function startPolling() {
    pollOnce();
    if (state.pollHandle) clearInterval(state.pollHandle);
    state.pollHandle = setInterval(() => {
      if (document.hidden) return;
      pollOnce();
    }, CFG.POLL_INTERVAL_MS || 30000);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) pollOnce();
    });
  }

  function startCardTimers() {
    if (state.cardTimerHandle) clearInterval(state.cardTimerHandle);
    state.cardTimerHandle = setInterval(tickCardTimers, 1000);
  }

  function startClock() {
    const clockEl = $('[data-vita-clock]');
    if (!clockEl) return;
    const tick = () => { clockEl.textContent = fmtClock(new Date()); };
    tick();
    if (state.clockHandle) clearInterval(state.clockHandle);
    state.clockHandle = setInterval(tick, 30000);
  }

  // === TABS ===

  function setupTabs() {
    $$('.vita-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        $$('.vita-tab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const target = tab.dataset.vitaTab;
        $$('.vita-tabpanel').forEach(p => p.hidden = p.dataset.vitaTabpanel !== target);
        if (target === 'reports' && !state.reportsLoaded) {
          loadReports(state.reportsCurrentPeriod);
        }
        if (target === 'qr' && !state.qrInited) {
          initQrTab();
        }
        if (target === 'menu' && !state.menuInited) {
          initMenuTab();
        }
        if (target === 'customfields' && !state.customFieldsInited) {
          initCustomFieldsTab();
        }
      });
    });
  }

  // ============================================================
  // === REPORTS — perf cache + lazy chart + custom date range
  // ============================================================

  // BUG 2 FIX: Local-aware date format (no UTC slice).
  function periodToRange(period) {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let from, to;
    if (period === 'today') { from = startOfDay; to = startOfDay; }
    else if (period === 'yesterday') {
      const y = new Date(startOfDay); y.setDate(y.getDate() - 1);
      from = y; to = y;
    }
    else if (period === '7d')  { from = new Date(startOfDay); from.setDate(from.getDate() - 6); to = startOfDay; }
    else if (period === '30d') { from = new Date(startOfDay); from.setDate(from.getDate() - 29); to = startOfDay; }
    else if (period === 'month') { from = new Date(now.getFullYear(), now.getMonth(), 1); to = startOfDay; }
    else { from = new Date(startOfDay); from.setDate(from.getDate() - 6); to = startOfDay; }
    return { from: fmtLocalISODate(from), to: fmtLocalISODate(to) };
  }

  // === Reports cache (localStorage, 5 dk TTL) ===

  function cacheKey(branch, from, to) {
    return `${REPORTS_CACHE_PREFIX}${branch}_${from}_${to}`;
  }

  function readReportsCache(branch, from, to) {
    try {
      const raw = localStorage.getItem(cacheKey(branch, from, to));
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj || !obj.ts || !obj.data) return null;
      if (Date.now() - obj.ts > REPORTS_CACHE_TTL_MS) return null;
      return { data: obj.data, cachedAt: obj.ts };
    } catch (_) { return null; }
  }

  function writeReportsCache(branch, from, to, data) {
    try {
      localStorage.setItem(cacheKey(branch, from, to), JSON.stringify({
        ts: Date.now(),
        data
      }));
    } catch (_) {
      // Quota full → silmeye çalış
      try {
        Object.keys(localStorage).forEach(k => {
          if (k.startsWith(REPORTS_CACHE_PREFIX)) localStorage.removeItem(k);
        });
        localStorage.setItem(cacheKey(branch, from, to), JSON.stringify({ ts: Date.now(), data }));
      } catch (_) {}
    }
  }

  function clearReportsCache(branch, from, to) {
    try {
      if (from && to) {
        localStorage.removeItem(cacheKey(branch, from, to));
      } else {
        Object.keys(localStorage).forEach(k => {
          if (k.startsWith(REPORTS_CACHE_PREFIX)) localStorage.removeItem(k);
        });
      }
    } catch (_) {}
  }

  // === Load reports ===

  async function loadReports(period, opts) {
    const force = opts && opts.force;
    let range;

    if (period === 'custom') {
      const fromEl = $('[data-vita-date-from]');
      const toEl = $('[data-vita-date-to]');
      const from = fromEl && fromEl.value;
      const to = toEl && toEl.value;
      if (!from || !to) return;
      range = { from, to };
    } else {
      range = periodToRange(period);
    }

    state.reportsCurrentPeriod = period;
    state.reportsCurrentRange = range;

    // Race guard: hızlı pill tıklamalarında eski fetch'in yeni render'ı override etmesini engelle.
    const requestId = ++state.reportsRequestId;
    const isStale = () => requestId !== state.reportsRequestId;

    const loading = $('[data-rep-loading]');
    const content = $('[data-rep-content]');

    // Cache hit → eager render
    if (!force) {
      const cached = readReportsCache(state.branch, range.from, range.to);
      if (cached) {
        if (isStale()) return;
        if (loading) loading.hidden = true;
        if (content) content.hidden = false;
        state.reportsLoaded = true;
        renderReports(cached.data, { cachedAt: cached.cachedAt });
        // Background refresh: 2dk'dan eski cache'i sessizce yenile
        if (Date.now() - cached.cachedAt > 2 * 60 * 1000) {
          backgroundRefreshReports(state.branch, range.from, range.to, requestId);
        }
        return;
      }
    }

    // Cache miss → eager skeleton + fetch
    if (loading) loading.hidden = false;
    if (content) content.hidden = true;
    // KPI'ları temizle ki kullanıcı stale değer görmesin
    clearReportsKPIs();

    try {
      const data = await api('reports', { branch: state.branch, from: range.from, to: range.to });
      if (isStale()) return; // Daha yeni bir click oldu, bu sonucu yansıtma
      writeReportsCache(state.branch, range.from, range.to, data);
      state.reportsLoaded = true;
      if (loading) loading.hidden = true;
      if (content) content.hidden = false;
      renderReports(data, { cachedAt: Date.now() });
    } catch (e) {
      if (isStale()) return;
      console.error('[Vitavien Panel] reports fail', e);
      if (loading) loading.innerHTML = `<p style="text-align:center;color:var(--v-late-fg);font-size:13px;">Rapor alınamadı: ${escapeHtml(e.message)}</p>`;
    }
  }

  function clearReportsKPIs() {
    ['revenue', 'sessions', 'avgBill', 'avgDuration'].forEach(k => {
      const el = document.querySelector(`[data-kpi="${k}"]`);
      if (el) el.innerHTML = '<span style="color:#B5B7AE;">—</span>';
      const foot = document.querySelector(`[data-kpi-foot="${k}"]`);
      if (foot) foot.textContent = '';
    });
    const rangeEl = document.querySelector('[data-rep-range]');
    if (rangeEl) rangeEl.textContent = 'Yükleniyor…';
  }

  async function backgroundRefreshReports(branch, from, to, originalRequestId) {
    try {
      const data = await api('reports', { branch, from, to });
      writeReportsCache(branch, from, to, data);
      // Stale guard + range guard: kullanıcı başka pill'e tıkladıysa dokunma
      if (originalRequestId !== state.reportsRequestId) return;
      if (state.reportsCurrentRange && state.reportsCurrentRange.from === from && state.reportsCurrentRange.to === to) {
        renderReports(data, { cachedAt: Date.now(), silent: true });
      }
    } catch (_) {}
  }

  // === Render reports ===

  function renderReports(d, meta) {
    meta = meta || {};

    // Range header
    const range = $('[data-rep-range]');
    if (range) {
      const span = diffDaysHuman(d.range.from, d.range.to);
      const fromFmt = formatDayLong(d.range.from);
      const toFmt = formatDayLong(d.range.to);
      const txt = d.range.from === d.range.to
        ? `${fromFmt}`
        : `${fromFmt} → ${toFmt} · ${span}`;
      range.textContent = txt;
    }

    // KPIs (eager)
    const setKpi = (k, html) => {
      const el = document.querySelector(`[data-kpi="${k}"]`);
      if (el) el.innerHTML = html;
    };
    setKpi('revenue', `${fmtMoney(d.overview.totalRevenue)}<span class="vita-unit">TL</span>`);
    setKpi('sessions', `${d.overview.sessions || '0'}`);
    setKpi('avgBill', `${fmtMoney(d.overview.avgBill)}<span class="vita-unit">TL</span>`);
    setKpi('avgDuration', `${d.overview.avgDurationMin || 0}<span class="vita-unit">dk</span>`);

    // KPI footnotes
    setKpiFoot('revenue', d.overview.sessions ? `${d.overview.sessions} hesap üzerinden` : 'Bu dönem hesap yok');
    setKpiFoot('sessions', d.overview.sessions ? 'kapanan hesap' : '—');
    setKpiFoot('avgBill', d.overview.avgBill > 0 ? 'kişi başı hesap ortalaması' : '—');
    setKpiFoot('avgDuration', d.overview.avgDurationMin > 0 ? 'masa başı ortalama' : '—');

    // Cache chip (son güncelleme)
    const cacheChip = $('[data-rep-cache-chip]');
    if (cacheChip && meta.cachedAt) {
      const sec = Math.floor((Date.now() - meta.cachedAt) / 1000);
      let label;
      if (sec < 5) label = 'Az önce';
      else if (sec < 60) label = `${sec} sn önce`;
      else if (sec < 3600) label = `${Math.floor(sec / 60)} dk önce`;
      else label = `${Math.floor(sec / 3600)} sa önce`;
      cacheChip.innerHTML = `<span>${label} güncellendi</span><button type="button" data-rep-force-refresh>Yenile</button>`;
    }

    // Store data for lazy chart render
    state.reports = d;
    state.chartsRendered.clear();

    // KPI'lar hemen render. Chart'lar visibility'e göre lazy.
    setupChartObserver();

    const asof = $('[data-rep-asof]');
    if (asof) asof.textContent = `Son güncelleme · ${new Date(d.asOf).toLocaleString('tr-TR')}`;
  }

  function setKpiFoot(k, txt) {
    const el = document.querySelector(`[data-kpi-foot="${k}"]`);
    if (el) el.textContent = txt;
  }

  function formatDayLong(iso) {
    const d = new Date(iso + 'T00:00:00');
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  function formatDayShort(iso) {
    const d = new Date(iso + 'T00:00:00');
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' });
  }

  // === Lazy chart rendering via IntersectionObserver ===

  function setupChartObserver() {
    if (state.chartObserver) {
      try { state.chartObserver.disconnect(); } catch (_) {}
    }
    if (!('IntersectionObserver' in window)) {
      // Fallback: hepsini render et
      renderAllCharts();
      return;
    }
    state.chartObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.dataset.lazyChart;
          if (id && !state.chartsRendered.has(id)) {
            renderChartById(id);
            state.chartsRendered.add(id);
            state.chartObserver.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: '120px' });

    document.querySelectorAll('[data-lazy-chart]').forEach(el => {
      state.chartObserver.observe(el);
    });
  }

  function renderAllCharts() {
    document.querySelectorAll('[data-lazy-chart]').forEach(el => {
      const id = el.dataset.lazyChart;
      if (id) {
        renderChartById(id);
        state.chartsRendered.add(id);
      }
    });
  }

  async function renderChartById(id) {
    const d = state.reports;
    if (!d) return;
    // ApexCharts dependent charts hariç hepsi sync
    if (id === 'revenue' || id === 'topproducts' || id === 'bottomproducts' || id === 'payment' || id === 'waiters') {
      await ensureApexLoaded();
    }
    switch (id) {
      case 'revenue': renderRevenueChart(d.revenueByDay); break;
      case 'heatmap': renderHeatmap(d.hourMatrix); break;
      case 'topproducts': renderProductsChart('rep-chart-topproducts', d.topProducts, 'olive'); break;
      case 'bottomproducts': renderBottomProductsPaged(d.bottomProducts); break;
      case 'payment': renderPaymentChart(d.paymentTotal); break;
      case 'waiters': renderWaitersChart(d.waiterPerf); break;
      case 'tableperf': renderTablePerf(d.tablePerf); break;
      case 'feedback': renderFeedback(d.feedbackCount); break;
    }
  }

  function vitaChartDefaults() {
    return {
      chart: {
        toolbar: { show: false },
        fontFamily: "'Inter', sans-serif",
        background: 'transparent',
        animations: { enabled: true, speed: 600 }
      },
      colors: ['#3F5D3A', '#6B8B5E', '#A06E15', '#983C32', '#3D5A6C', '#8E948A'],
      grid: { borderColor: '#E8E1D4', strokeDashArray: 0, padding: { left: 12, right: 12 } },
      dataLabels: { enabled: false },
      tooltip: { theme: 'light', style: { fontSize: '12px', fontFamily: "'Inter', sans-serif" } },
      xaxis: {
        labels: { style: { colors: '#5C6359', fontSize: '11px', fontWeight: 500 } },
        axisBorder: { color: '#E8E1D4' },
        axisTicks: { color: '#E8E1D4' }
      },
      yaxis: { labels: { style: { colors: '#5C6359', fontSize: '11px', fontWeight: 500 } } }
    };
  }

  let charts = {};
  function destroyChart(id) {
    if (charts[id]) { try { charts[id].destroy(); } catch (_) {} charts[id] = null; }
  }

  function renderRevenueChart(series) {
    if (!window.ApexCharts || !series) return;
    destroyChart('revenue');
    const el = document.querySelector('#rep-chart-revenue');
    if (!el) return;
    el.innerHTML = '';
    if (!series.length) { el.innerHTML = '<p class="vita-rep-empty">Bu dönemde gelir yok</p>'; return; }

    const opts = Object.assign({}, vitaChartDefaults(), {
      chart: { ...vitaChartDefaults().chart, type: 'bar', height: 260 },
      series: [{ name: 'Gelir (TL)', data: series.map(s => s.value) }],
      xaxis: { ...vitaChartDefaults().xaxis, categories: series.map(s => formatDayShort(s.date)) },
      yaxis: { ...vitaChartDefaults().yaxis, labels: { ...vitaChartDefaults().yaxis.labels, formatter: v => Math.round(v).toLocaleString('tr-TR') } },
      plotOptions: { bar: { borderRadius: 5, columnWidth: '58%' } },
      colors: ['#3F5D3A']
    });
    charts.revenue = new ApexCharts(el, opts);
    charts.revenue.render();
  }

  function renderHeatmap(matrix) {
    const el = document.querySelector('#rep-chart-heatmap');
    if (!el || !matrix) return;
    const days = ['Pzt','Sal','Çar','Per','Cum','Cmt','Paz'];
    const flat = matrix.flat();
    const max = Math.max(1, ...flat);
    const intensity = (v) => v === 0 ? 0 : Math.min(5, Math.ceil((v / max) * 5));
    const totalSessions = flat.reduce((a, b) => a + b, 0);

    if (totalSessions === 0) {
      el.innerHTML = '<p class="vita-rep-empty">Bu dönemde session yok</p>';
      return;
    }

    let html = '<div class="vita-heatmap">';
    html += '<div class="vita-hm-corner">&nbsp;</div>';
    for (let h = 0; h < 24; h++) html += `<div class="vita-hm-label">${h}</div>`;
    for (let d = 0; d < 7; d++) {
      html += `<div class="vita-hm-day">${days[d]}</div>`;
      for (let h = 0; h < 24; h++) {
        const v = matrix[d][h];
        html += `<div class="vita-hm-cell" data-h="${intensity(v)}" title="${days[d]} ${h}:00 — ${v} hesap"></div>`;
      }
    }
    html += '</div>';
    el.innerHTML = html;
  }

  // Bottom products için pagination wrapper (10 ürün/sayfa).
  // Top 10'un altındaki tüm görünür menü ürünleri burada, çoktan aza sıralı.
  state.bottomPage = state.bottomPage || 1;
  const BOTTOM_PAGE_SIZE = 10;

  function renderBottomProductsPaged(all) {
    const cardEl = document.querySelector('[data-lazy-chart="bottomproducts"]');
    const chartEl = document.querySelector('#rep-chart-bottomproducts');
    if (!cardEl || !chartEl) return;
    const list = Array.isArray(all) ? all : [];
    const total = list.length;
    const pageSize = BOTTOM_PAGE_SIZE;
    const pageCount = Math.max(1, Math.ceil(total / pageSize));
    if (state.bottomPage > pageCount) state.bottomPage = 1;
    const page = state.bottomPage;
    const start = (page - 1) * pageSize;
    const end = Math.min(start + pageSize, total);
    const slice = list.slice(start, end);

    // Pagination UI — chart'ın ALTINA ekle (idempotent)
    let nav = cardEl.querySelector('[data-bp-nav]');
    if (!nav) {
      nav = document.createElement('div');
      nav.setAttribute('data-bp-nav', '');
      nav.style.cssText = 'display:flex; align-items:center; gap:10px; margin:12px 0 0; font-size:12px; color:#5C6359;';
      nav.innerHTML = `
        <button data-bp-prev style="background:#FFF; border:1px solid #E8E1D4; padding:5px 10px; border-radius:4px; cursor:pointer; font:600 12px Inter,sans-serif; color:#3F5D3A;">‹ Önceki</button>
        <span data-bp-range style="font-variant-numeric:tabular-nums;">—</span>
        <button data-bp-next style="background:#FFF; border:1px solid #E8E1D4; padding:5px 10px; border-radius:4px; cursor:pointer; font:600 12px Inter,sans-serif; color:#3F5D3A;">Sonraki ›</button>
        <span data-bp-pageinfo style="margin-left:auto; color:#8E948A;">Sayfa —</span>
      `;
      // chart'ın sonrasına ekle
      if (chartEl.nextSibling) {
        chartEl.parentNode.insertBefore(nav, chartEl.nextSibling);
      } else {
        cardEl.appendChild(nav);
      }
      nav.querySelector('[data-bp-prev]').addEventListener('click', () => {
        if (state.bottomPage > 1) { state.bottomPage--; renderBottomProductsPaged(state.reports.bottomProducts); }
      });
      nav.querySelector('[data-bp-next]').addEventListener('click', () => {
        const d = state.reports && Array.isArray(state.reports.bottomProducts) ? state.reports.bottomProducts : [];
        const pc = Math.max(1, Math.ceil(d.length / BOTTOM_PAGE_SIZE));
        if (state.bottomPage < pc) { state.bottomPage++; renderBottomProductsPaged(d); }
      });
    }
    nav.querySelector('[data-bp-range]').textContent = total ? `${start + 1}–${end} / ${total}` : '0 ürün';
    nav.querySelector('[data-bp-pageinfo]').textContent = `Sayfa ${page} / ${pageCount}`;
    nav.querySelector('[data-bp-prev]').disabled = (page <= 1);
    nav.querySelector('[data-bp-next]').disabled = (page >= pageCount);
    nav.querySelector('[data-bp-prev]').style.opacity = (page <= 1) ? '0.4' : '1';
    nav.querySelector('[data-bp-next]').style.opacity = (page >= pageCount) ? '0.4' : '1';

    // Sabit max: tüm bottom listesinin en yüksek count'ı — sayfalar arası ölçek tutarlı kalır
    const globalMax = list.reduce((m, p) => Math.max(m, Number(p.count) || 0), 0);
    renderProductsChart('rep-chart-bottomproducts', slice, 'mist', globalMax);
  }

  function renderProductsChart(id, products, paletteKey, xMax) {
    if (!window.ApexCharts || !products) return;
    destroyChart(id);
    const el = document.querySelector('#' + id);
    if (!el) return;
    el.innerHTML = '';
    if (!products.length) { el.innerHTML = '<p class="vita-rep-empty">Veri yok</p>'; return; }

    const color = paletteKey === 'mist' ? '#8E948A' : '#3F5D3A';
    // products desc geliyor (en çok satan başta). ApexCharts horizontal bar default:
    // cats[0] EN ÜSTTE. Yani ham array yeterli — en çok satan üstte, en azı altta.
    // xMax verilirse x ekseni sabit tutulur (pagination'lı chart'lar için ölçek korunur).
    const xaxisCfg = { ...vitaChartDefaults().xaxis, categories: products.map(p => p.name) };
    if (typeof xMax === 'number' && xMax > 0) xaxisCfg.max = xMax;
    const opts = Object.assign({}, vitaChartDefaults(), {
      chart: { ...vitaChartDefaults().chart, type: 'bar', height: Math.max(220, products.length * 30) },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '70%' } },
      series: [{ name: 'Adet', data: products.map(p => p.count) }],
      xaxis: xaxisCfg,
      colors: [color]
    });
    charts[id] = new ApexCharts(el, opts);
    charts[id].render();
  }

  function renderPaymentChart(p) {
    if (!window.ApexCharts) return;
    destroyChart('payment');
    const el = document.querySelector('#rep-chart-payment');
    if (!el || !p) return;
    el.innerHTML = '';
    const total = (p.cash || 0) + (p.card || 0) + (p.other || 0);
    if (!total) { el.innerHTML = '<p class="vita-rep-empty">Ödeme verisi yok</p>'; return; }

    const opts = Object.assign({}, vitaChartDefaults(), {
      chart: { ...vitaChartDefaults().chart, type: 'donut', height: 260 },
      labels: ['Nakit', 'Kart', 'Diğer'],
      series: [p.cash || 0, p.card || 0, p.other || 0],
      colors: ['#6B8B5E', '#3D5A6C', '#A06E15'],
      legend: { position: 'bottom', fontSize: '12px', labels: { colors: '#5C6359' }, markers: { width: 10, height: 10 } },
      plotOptions: { pie: { donut: { size: '66%', labels: { show: true, total: { show: true, label: 'Toplam', fontSize: '11px', fontWeight: 600, color: '#8E948A', formatter: () => Math.round(total).toLocaleString('tr-TR') + ' TL' } } } } },
      stroke: { width: 2, colors: ['#FFFFFF'] }
    });
    charts.payment = new ApexCharts(el, opts);
    charts.payment.render();
  }

  function renderWaitersChart(waiters) {
    if (!window.ApexCharts || !waiters) return;
    destroyChart('waiters');
    const el = document.querySelector('#rep-chart-waiters');
    if (!el) return;
    el.innerHTML = '';
    if (!waiters.length) { el.innerHTML = '<p class="vita-rep-empty">Garson verisi yok</p>'; return; }

    const opts = Object.assign({}, vitaChartDefaults(), {
      chart: { ...vitaChartDefaults().chart, type: 'bar', height: Math.max(220, waiters.length * 38) },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
      series: [{ name: 'Ciro (TL)', data: waiters.map(w => Math.round(w.revenue)) }],
      xaxis: { ...vitaChartDefaults().xaxis, categories: waiters.map(w => w.name) },
      colors: ['#3F5D3A']
    });
    charts.waiters = new ApexCharts(el, opts);
    charts.waiters.render();
  }

  state.tablePerfSort = state.tablePerfSort || { key: 'revenue', dir: 'desc' };

  function renderTablePerf(rows) {
    const el = document.querySelector('#rep-table-perf');
    if (!el) return;
    if (!rows || !rows.length) {
      el.innerHTML = '<p class="vita-rep-empty">Bu dönemde kapanan masa yok</p>';
      return;
    }
    const { key, dir } = state.tablePerfSort;
    const sorted = rows.slice().sort((a, b) => {
      let va, vb;
      if (key === 'name') { va = (a.name||'').toLowerCase(); vb = (b.name||'').toLowerCase(); return dir==='asc' ? va.localeCompare(vb,'tr') : vb.localeCompare(va,'tr'); }
      else if (key === 'sessions') { va = Number(a.sessions)||0; vb = Number(b.sessions)||0; }
      else if (key === 'revenue') { va = Number(a.revenue)||0; vb = Number(b.revenue)||0; }
      else if (key === 'avgDuration') { va = Number(a.avgDuration)||0; vb = Number(b.avgDuration)||0; }
      else if (key === 'complaints') { va = Number(a.complaints)||0; vb = Number(b.complaints)||0; }
      else { va = 0; vb = 0; }
      return dir === 'asc' ? va - vb : vb - va;
    });

    const arrow = (k) => key === k ? (dir === 'asc' ? ' ▲' : ' ▼') : '<span style="opacity:.3"> ⇅</span>';
    const headCell = (k, label) =>
      `<div data-tp-sort="${k}" style="cursor:pointer; user-select:none;" title="Sırala">${label}${arrow(k)}</div>`;

    let html = `
      <div class="vita-table-perf-row head">
        ${headCell('name','Masa')}
        ${headCell('sessions','Oturum')}
        ${headCell('revenue','Ciro (TL)')}
        ${headCell('avgDuration','Ort. süre (dk)')}
        ${headCell('complaints','Şikayet')}
      </div>`;
    sorted.forEach(r => {
      const complaintClass = r.complaints > 0 ? 'complaint-bad' : 'complaint-good';
      html += `
        <div class="vita-table-perf-row">
          <div>${escapeHtml(r.name)}</div>
          <div>${r.sessions}</div>
          <div>${fmtMoney(r.revenue)}</div>
          <div>${r.avgDuration}</div>
          <div class="${complaintClass}">${r.complaints || '—'}</div>
        </div>`;
    });
    el.innerHTML = html;

    el.querySelectorAll('[data-tp-sort]').forEach(h => {
      h.addEventListener('click', () => {
        const k = h.getAttribute('data-tp-sort');
        if (state.tablePerfSort.key === k) {
          state.tablePerfSort.dir = state.tablePerfSort.dir === 'asc' ? 'desc' : 'asc';
        } else {
          state.tablePerfSort.key = k;
          state.tablePerfSort.dir = (k === 'name') ? 'asc' : 'desc';
        }
        renderTablePerf(rows);
      });
    });
  }

  function renderFeedback(fb) {
    const el = document.querySelector('#rep-feedback');
    if (!el) return;
    if (!fb || !fb.total) {
      el.innerHTML = '<p class="vita-rep-empty">Bu dönemde geri bildirim yok. (Form devreye girince burası dolacak.)</p>';
      return;
    }
    el.innerHTML = `
      <div class="vita-fb-item positive">
        <div class="count">${fb.positive}</div>
        <div class="label">Memnun</div>
      </div>
      <div class="vita-fb-item mixed">
        <div class="count">${fb.mixed}</div>
        <div class="label">Karışık</div>
      </div>
      <div class="vita-fb-item negative">
        <div class="count">${fb.negative}</div>
        <div class="label">Şikayet</div>
      </div>
    `;
  }

  // === Reports controls (pills + custom range + force refresh) ===

  function setupReportsControls() {
    $$('.vita-date-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const period = pill.dataset.period;

        $$('.vita-date-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        const custom = $('[data-vita-date-custom]');

        if (period === 'custom') {
          if (custom) {
            custom.hidden = false;
            // Default değerler: 7 gün öncesi - bugün
            const r = periodToRange('7d');
            const fromEl = $('[data-vita-date-from]');
            const toEl = $('[data-vita-date-to]');
            if (fromEl && !fromEl.value) fromEl.value = r.from;
            if (toEl && !toEl.value) toEl.value = r.to;
          }
        } else {
          if (custom) custom.hidden = true;
          loadReports(period);
        }
      });
    });

    // Custom range apply
    const applyBtn = $('[data-vita-date-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        const fromEl = $('[data-vita-date-from]');
        const toEl = $('[data-vita-date-to]');
        if (!fromEl || !toEl || !fromEl.value || !toEl.value) return;
        if (fromEl.value > toEl.value) {
          // Swap
          const tmp = fromEl.value; fromEl.value = toEl.value; toEl.value = tmp;
        }
        loadReports('custom');
      });
    }

    // Force refresh — delegate
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-rep-force-refresh]')) {
        const r = state.reportsCurrentRange;
        if (r) {
          clearReportsCache(state.branch, r.from, r.to);
          loadReports(state.reportsCurrentPeriod, { force: true });
        }
      }
    });
  }

  async function ensureApexLoaded() {
    if (window.ApexCharts) return;
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/apexcharts@3.49.1/dist/apexcharts.min.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // ============================================================
  // === QR ÜRETECİ
  // ============================================================

  async function ensureQrLibLoaded() {
    if (window.QRious) return;
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/qrious@4.0.2/dist/qrious.min.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  async function ensureJSZipLoaded() {
    if (window.JSZip) return;
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  const QR_FULL_SIZE = 1000;
  const QR_PREVIEW_PX = 220;
  const QR_PADDING = 60; // QR kenarı + beyaz çerçeve, baskıda kesilmesin diye

  // Şube başına masa yapısı — yeni şube eklerken bu config'e zone ekle.
  // slug URL'de görünür (`?masa=bahce-1`), label panelde + menüdeki rozette ("Masa Bahçe 1").
  const BRANCH_TABLES = {
    sisli: [
      { slug: 'bahce', label: 'Bahçe', count: 2 },
      { slug: 'salon', label: 'Salon', count: 13 }
    ]
  };

  function buildBranchMasaList(branchCode) {
    const zones = BRANCH_TABLES[branchCode] || [];
    const list = [];
    for (const z of zones) {
      for (let i = 1; i <= z.count; i++) {
        list.push({
          slug: `${z.slug}-${i}`,             // URL: ?masa=bahce-1
          fileName: `${z.slug}-${i}`,         // ZIP: bahce-1.png
          label: `${z.label} ${i}`,           // Kart: "Bahçe 1"
          zone: z.label,
          zoneSlug: z.slug,
          index: i
        });
      }
    }
    return list;
  }

  async function initQrTab() {
    state.qrInited = true;
    await ensureQrLibLoaded();
    const get = (sel) => document.querySelector(sel);
    const refresh = () => renderQrPreview();
    get('[data-qr-refresh]').addEventListener('click', refresh);
    const dlAll = get('[data-qr-download-all]');
    if (dlAll) dlAll.addEventListener('click', downloadAllAsZip);
    ['[data-qr-baseurl]', '[data-qr-branch]'].forEach(sel => {
      const el = get(sel);
      if (el) el.addEventListener('change', refresh);
    });
    const previewEl = get('[data-qr-preview]');
    if (previewEl) previewEl.addEventListener('click', handleSingleQrDownload);
    refresh();
  }

  function getQrFormState() {
    return {
      branch: document.querySelector('[data-qr-branch]').value,
      baseUrl: document.querySelector('[data-qr-baseurl]').value.replace(/\/$/, '')
    };
  }

  function renderQrPreview() {
    const cfg = getQrFormState();
    const masaList = buildBranchMasaList(cfg.branch);
    const stage = document.querySelector('[data-qr-preview]');
    if (!masaList.length) {
      stage.innerHTML = '<p class="vita-qr-empty">Bu şube için tanımlı masa yok.</p>';
      return;
    }
    stage.innerHTML = '';

    let currentZone = '';
    for (const m of masaList) {
      // Yeni zone başlığı
      if (m.zone !== currentZone) {
        currentZone = m.zone;
        const header = document.createElement('div');
        header.className = 'vita-qr-zone-header';
        header.style.cssText = 'grid-column: 1 / -1; font-family: Fraunces, Georgia, serif; font-weight: 500; color: #3F5D3A; font-size: 18px; padding: 12px 0 4px; border-bottom: 1px solid #E8E1D4; margin-top: 8px;';
        header.textContent = m.zone;
        stage.appendChild(header);
      }

      const url = `${cfg.baseUrl}?masa=${m.slug}`;
      const card = document.createElement('div');
      card.className = 'vita-qr-card-min';
      card.dataset.masa = m.slug;
      card.dataset.fileName = m.fileName;
      card.dataset.label = m.label;
      card.innerHTML = `
        <div class="vita-qr-thumb" data-qr-canvas></div>
        <div class="vita-qr-meta">
          <span class="vita-qr-table-code">${m.label}</span>
          <button type="button" class="vita-qr-download-btn" data-qr-download>İndir</button>
        </div>
      `;
      stage.appendChild(card);

      try {
        const c = document.createElement('canvas');
        new window.QRious({
          element: c,
          value: url,
          size: QR_FULL_SIZE,
          foreground: '#000000',
          background: '#FFFFFF',
          level: 'M',
          padding: QR_PADDING
        });
        c.style.width = QR_PREVIEW_PX + 'px';
        c.style.height = QR_PREVIEW_PX + 'px';
        card.querySelector('[data-qr-canvas]').appendChild(c);
      } catch (e) {
        console.warn('[QR] failed for ' + m.slug, e);
      }
    }
  }

  function handleSingleQrDownload(e) {
    if (!e.target.matches('[data-qr-download]')) return;
    const card = e.target.closest('.vita-qr-card-min');
    if (!card) return;
    const fileName = card.dataset.fileName || card.dataset.masa;
    const canvas = card.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = `${fileName}.png`;
    link.href = canvas.toDataURL('image/png');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async function downloadAllAsZip() {
    const cards = document.querySelectorAll('.vita-qr-card-min');
    if (cards.length === 0) {
      alert('Önce önizleme oluştur.');
      return;
    }
    await ensureJSZipLoaded();
    const cfg = getQrFormState();
    const zip = new window.JSZip();
    cards.forEach(card => {
      const fileName = card.dataset.fileName || card.dataset.masa;
      const canvas = card.querySelector('canvas');
      if (!canvas) return;
      const dataUrl = canvas.toDataURL('image/png');
      const base64 = dataUrl.split(',')[1];
      zip.file(`${fileName}.png`, base64, { base64: true });
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    const link = document.createElement('a');
    link.download = `vitavien-${cfg.branch}-qr-masalar.zip`;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }

  // === BOOT ===

  async function startApp() {
    setupTabs();
    setupReportsControls();
    startClock();
    startPolling();
    startCardTimers();

    ensureApexLoaded().catch(() => console.warn('[Vitavien] ApexCharts yüklenemedi'));

    $$('[data-vita-side-close]').forEach(el => el.addEventListener('click', closeSidePanel));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSidePanel();
    });
    const sideContainer = $('[data-vita-side]');
    if (sideContainer) {
      sideContainer.addEventListener('click', (e) => {
        if (!e.target.closest('.vita-side-sheet')) {
          closeSidePanel();
        }
      });
    }

    $('[data-vita-logout]').addEventListener('click', () => {
      if (!confirm('Çıkış yapılsın mı? Şifreyi tekrar girmen gerekir.')) return;
      deleteCookie(COOKIE_NAME);
      location.reload();
    });
  }

  function setupGate() {
    const form = $('[data-vita-gate-form]');
    const errEl = $('[data-vita-error]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errEl.textContent = '';
      const pwd = $('[data-vita-pwd]').value;
      if (!pwd) return;
      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Kontrol ediliyor…';
      const ok = await tryUnlock(pwd);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Gir';
      if (ok) {
        showShell();
      } else {
        errEl.textContent = 'Şifre hatalı veya panel motoru ulaşılamıyor.';
        $('[data-vita-pwd]').select();
      }
    });
  }

  function init() {
    setupGate();
    document.body.classList.add('vita-panel-active');
    if (getCookie(COOKIE_NAME)) {
      showShell();
      verifyAuthAsync();
    } else {
      showGate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============================================================
  // === MENÜ YÖNETİMİ SEKMESI (Yeni — Sheet UI'sini devraldı)
  // ============================================================

  const KATEGORI_OPTIONS = [
    { v: '', label: '— Gizli —' },
    { v: 'dondurma-kup', label: 'Dondurma & Kup' },
    { v: 'kruvasan', label: 'Kruvasan' },
    { v: 'tatlilar', label: 'Tatlılar' },
    { v: 'makaron-kurabiyeler', label: 'Makaron & Kurabiyeler' },
    { v: 'soguk-kahveler', label: 'Soğuk Kahveler' },
    { v: 'soguk-icecekler', label: 'Soğuk İçecekler' },
    { v: 'sicak-kahveler', label: 'Sıcak Kahveler' },
    { v: 'sicak-icecekler', label: 'Sıcak İçecekler' }
  ];

  const LANG_LABELS = { tr: 'Türkçe', en: 'English', es: 'Español', ru: 'Русский' };
  const LANG_ORDER = ['tr', 'en', 'es', 'ru'];

  state.menuInited = false;
  state.menuProducts = [];
  state.menuFilter = { search: '', kategori: '', goster: 'all' };
  // Her satırın o anki aktif dili ve henüz kaydedilmemiş 4-dil taslakları
  // { cloposId: { activeLang: 'tr', tr: '...', en: '...', es: '...', ru: '...' } }
  state.menuRowDrafts = {};

  async function initMenuTab() {
    state.menuInited = true;
    const container = $('[data-vita-tabpanel="menu"]');
    if (!container) {
      console.warn('[Vitavien Panel] Menü tabpanel bulunamadı.');
      return;
    }
    container.innerHTML = renderMenuShell();
    bindMenuControls(container);
    await loadMenuProducts(container);
  }

  function renderMenuShell() {
    return `
      <div class="vita-menu-mgmt" style="padding: 24px; max-width: 1400px; margin: 0 auto;">
        <div class="vita-menu-head" style="display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:16px; flex-wrap:wrap;">
          <div style="flex:1; min-width:280px;">
            <h2 style="font-family: Fraunces, Georgia, serif; font-weight: 500; color: #3F5D3A; margin: 0 0 4px;">Menü Yönetimi</h2>
            <p style="color:#5C6359; margin:0; font-size:13px; line-height:1.5;"><strong>Kaydet</strong> = değişikliği bu panele yazar, müşteri menüsü etkilenmez. <strong>Şimdi yayına al</strong> = tüm menüyü Shopify'a aktarır (~90 sn), müşteri menüsü güncellenir.</p>
          </div>
          <div style="display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
            <button data-menu-pollnow title="Clopos'tan anlık ürün ve adisyon verisi çeker (~10 sn). Cron'u beklemeden hemen güncel veri." style="background:#FFF; color:#3F5D3A; border:1px solid #3F5D3A; padding:9px 14px; border-radius:6px; cursor:pointer; font-weight:600; font-size:13px;">↻ Clopos'tan anlık çek</button>
            <button data-menu-syncnow title="Tüm menü ayarlarını Shopify'a aktarır — ~90 sn, müşteri menüsü güncellenir" style="background:#3F5D3A; color:#FAF7F2; border:none; padding:10px 18px; border-radius:6px; cursor:pointer; font-weight:600; font-size:13px;">⟳ Şimdi yayına al</button>
          </div>
        </div>

        <div class="vita-menu-filters" style="display:flex; flex-wrap:wrap; gap:12px; margin-bottom:12px; align-items:center;">
          <input data-menu-search type="text" placeholder="Ara: ürün adı veya kategori…" style="flex:1; min-width:220px; padding:8px 12px; border:1px solid #E8E1D4; border-radius:6px; font:14px/1 Inter,sans-serif;">
          <select data-menu-kategori-filter title="Kategori grubu filtresi" style="padding:8px 12px; border:1px solid #E8E1D4; border-radius:6px; font:14px/1 Inter,sans-serif;">
            <option value="">Tüm kategori grupları</option>
            ${KATEGORI_OPTIONS.filter(o => o.v).map(o => `<option value="${o.v}">${o.label}</option>`).join('')}
            <option value="__empty">— Boş (kategorisiz) —</option>
          </select>
          <select data-menu-goster-filter title="Görünürlük filtresi" style="padding:8px 12px; border:1px solid #E8E1D4; border-radius:6px; font:14px/1 Inter,sans-serif;">
            <option value="all">Hepsi</option>
            <option value="visible">Görünür</option>
            <option value="hidden">Gizli</option>
          </select>
          <span data-menu-count style="color:#8E948A; font-size:12px;"></span>
        </div>

        <div class="vita-menu-status" data-menu-status style="margin-bottom:12px; font-size:13px; color:#5C6359;"></div>

        <div class="vita-menu-table-wrap" style="overflow-x:auto; background:#FFF; border:1px solid #E8E1D4; border-radius:8px;">
          <table data-menu-table style="width:100%; border-collapse:collapse; font-size:13px;">
            <thead style="background:#FAF7F2; border-bottom:1px solid #E8E1D4; position:sticky; top:0;">
              <tr>
                <th style="text-align:left; padding:10px 12px; font-weight:600; color:#3F5D3A;">Ürün (Clopos)</th>
                <th style="text-align:left; padding:10px 12px; font-weight:600; color:#3F5D3A; width:120px;">Fiyat</th>
                <th style="text-align:left; padding:10px 12px; font-weight:600; color:#3F5D3A; width:220px;">Kategori grubu</th>
                <th style="text-align:left; padding:10px 12px; font-weight:600; color:#3F5D3A; min-width:360px;">Açıklama <span style="font-weight:400; color:#8E948A; font-size:11px;">(dil için kutunun altındaki kısaltmaya tıkla)</span></th>
                <th style="text-align:center; padding:10px 12px; font-weight:600; color:#3F5D3A; width:90px;">Göster</th>
                <th style="text-align:right; padding:10px 12px; font-weight:600; color:#3F5D3A; width:120px;">İşlem</th>
              </tr>
            </thead>
            <tbody data-menu-rows></tbody>
          </table>
        </div>

        <div style="margin-top:16px; padding:14px 16px; background:#FAF7F2; border-radius:6px; font-size:12px; color:#5C6359; line-height:1.7;">
          <strong style="color:#3F5D3A;">Nasıl çalışır:</strong>
          <ul style="margin:6px 0 0 18px; padding:0;">
            <li><strong>Kaydet</strong> → değişikliği bu panele yazar. Müşteri menüsünde henüz görünmez.</li>
            <li><strong>↻ Clopos'tan anlık çek</strong> → kasadaki son fiyat/adisyon verisini hemen alır (cron'u beklemeden, ~10 sn).</li>
            <li><strong>⟳ Şimdi yayına al</strong> → bu paneldeki tüm ayarları Shopify'a aktarır (~90 sn).</li>
            <li>Yeni Clopos ürünleri her saat başı otomatik buraya düşer (görünür=Açık, kategori=Boş).</li>
            <li>Açıklama kutusunun altında <strong>TR / EN / ES / RU</strong> kısaltmaları var. Tıkla, o dile geç, yaz, Kaydet. Doluyken kısaltma yeşil dolu (●), boşken gri boş (○).</li>
          </ul>
        </div>
      </div>
    `;
  }

  function bindMenuControls(container) {
    $('[data-menu-search]', container).addEventListener('input', (e) => {
      state.menuFilter.search = e.target.value.toLowerCase();
      renderMenuRows(container);
    });
    $('[data-menu-kategori-filter]', container).addEventListener('change', (e) => {
      state.menuFilter.kategori = e.target.value;
      renderMenuRows(container);
    });
    $('[data-menu-goster-filter]', container).addEventListener('change', (e) => {
      state.menuFilter.goster = e.target.value;
      renderMenuRows(container);
    });
    $('[data-menu-syncnow]', container).addEventListener('click', () => triggerSyncNow(container));
    $('[data-menu-pollnow]', container).addEventListener('click', () => triggerPollNow(container));
  }

  // Bir satırın draft state'ini al; yoksa products'tan oluştur.
  function getRowDraft(cloposId) {
    const id = String(cloposId);
    if (state.menuRowDrafts[id]) return state.menuRowDrafts[id];
    const p = state.menuProducts.find(x => String(x.clopos_id) === id) || {};
    const draft = {
      activeLang: 'tr',
      tr: p.aciklama_tr || '',
      en: p.aciklama_en || '',
      es: p.aciklama_es || '',
      ru: p.aciklama_ru || ''
    };
    state.menuRowDrafts[id] = draft;
    return draft;
  }

  async function loadMenuProducts(container) {
    const statusEl = $('[data-menu-status]', container);
    statusEl.textContent = 'Ürünler yükleniyor…';
    try {
      const data = await api('products_list', { branch: state.branch });
      state.menuProducts = (data && data.products) ? data.products : (Array.isArray(data) ? data : []);
      // Yeni veri geldi — eski row draft'ları temizle (sunucudan gelen taze değer kullanılsın)
      state.menuRowDrafts = {};
      statusEl.textContent = `${state.menuProducts.length} ürün hazır. Son güncelleme: ${fmtClock(new Date())}`;
      renderMenuRows(container);
    } catch (e) {
      statusEl.textContent = 'Hata: ' + e.message;
    }
  }

  function applyMenuFilter() {
    const { search, kategori, goster } = state.menuFilter;
    return state.menuProducts.filter(p => {
      if (search) {
        const hay = ((p.clopos_isim || '') + ' ' + (p.kategori_clopos || '')).toLowerCase();
        if (!hay.includes(search)) return false;
      }
      if (kategori === '__empty') {
        if ((p.kategori_grup || '').trim() !== '') return false;
      } else if (kategori) {
        if ((p.kategori_grup || '') !== kategori) return false;
      }
      if (goster === 'visible' && !p.goster) return false;
      if (goster === 'hidden' && p.goster) return false;
      return true;
    });
  }

  function renderMenuRows(container) {
    const tbody = $('[data-menu-rows]', container);
    const countEl = $('[data-menu-count]', container);
    const filtered = applyMenuFilter();
    countEl.textContent = `${filtered.length} / ${state.menuProducts.length} ürün`;

    if (!filtered.length) {
      tbody.innerHTML = `<tr><td colspan="6" style="padding:24px; text-align:center; color:#8E948A;">Filtre kriterine uyan ürün yok.</td></tr>`;
      return;
    }
    tbody.innerHTML = filtered.map(p => menuRowHtml(p)).join('');
    $$('tr[data-menu-row]', tbody).forEach(tr => {
      const id = tr.dataset.menuRow;
      $('[data-action="save"]', tr).addEventListener('click', () => saveMenuRow(id, tr));
      // Textarea'da yazılan içeriği aktif dilin draft'ına yansıt
      const ta = $('[data-field="aciklama"]', tr);
      if (ta) {
        ta.addEventListener('input', () => {
          const draft = getRowDraft(id);
          draft[draft.activeLang] = ta.value;
        });
      }
      // Dil chip'lerine click handler
      $$('[data-lang-chip]', tr).forEach(chip => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          const newLang = chip.dataset.langChip;
          switchRowLang(id, newLang, tr);
        });
      });
      // FIX 2026-05-16: Göster toggle ve Kategori dropdown otomatik save
      // — Hakan toggle'ı değiştirip "Şimdi yayına al" basabiliyor, ara Save unutuluyordu.
      const gosterEl = $('[data-field="goster"]', tr);
      if (gosterEl) {
        gosterEl.addEventListener('change', () => saveMenuRow(id, tr));
      }
      const kategoriEl = $('[data-field="kategori_grup"]', tr);
      if (kategoriEl) {
        kategoriEl.addEventListener('change', () => saveMenuRow(id, tr));
      }
    });
  }

  function switchRowLang(cloposId, newLang, tr) {
    const draft = getRowDraft(cloposId);
    const ta = $('[data-field="aciklama"]', tr);
    // Mevcut textarea içeriğini şu anki aktif dile yaz (kullanıcının yazdıklarını kaybetme)
    if (ta) draft[draft.activeLang] = ta.value;
    draft.activeLang = newLang;
    // Sadece bu satırı yeniden render et
    const newRow = document.createElement('tbody');
    newRow.innerHTML = menuRowHtml(
      state.menuProducts.find(p => String(p.clopos_id) === String(cloposId)) || {}
    );
    const fresh = newRow.firstElementChild;
    tr.replaceWith(fresh);
    // Yeni satıra event handler'ları yeniden bağla
    $('[data-action="save"]', fresh).addEventListener('click', () => saveMenuRow(cloposId, fresh));
    const newTa = $('[data-field="aciklama"]', fresh);
    if (newTa) {
      newTa.focus();
      newTa.addEventListener('input', () => {
        const d = getRowDraft(cloposId);
        d[d.activeLang] = newTa.value;
      });
    }
    $$('[data-lang-chip]', fresh).forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        switchRowLang(cloposId, chip.dataset.langChip, fresh);
      });
    });
    // FIX 2026-05-16: Auto-save (toggle + kategori) — switchRowLang sonrası da rebind
    const fGoster = $('[data-field="goster"]', fresh);
    if (fGoster) fGoster.addEventListener('change', () => saveMenuRow(cloposId, fresh));
    const fKategori = $('[data-field="kategori_grup"]', fresh);
    if (fKategori) fKategori.addEventListener('change', () => saveMenuRow(cloposId, fresh));
  }

  function menuRowHtml(p) {
    const id = String(p.clopos_id);
    const isim = (p.clopos_isim || '').replace(/</g, '&lt;');
    const fiyat = Number(p.fiyat || 0);
    const kgrup = (p.kategori_grup || '').trim();
    const goster = p.goster ? 1 : 0;
    const draft = getRowDraft(id);
    const lang = draft.activeLang;
    const aciklama = (draft[lang] || '').replace(/</g, '&lt;');
    const opts = KATEGORI_OPTIONS.map(o => `<option value="${o.v}" ${o.v === kgrup ? 'selected' : ''}>${o.label}</option>`).join('');
    // Tıklanabilir dil chip'leri — aktif olan altı çizili + yeşil dolu/gri boş indikatör
    const langChips = LANG_ORDER.map(l => {
      const filled = (draft[l] || '').trim().length > 0;
      const isActive = l === lang;
      const color = filled ? '#3F5D3A' : '#8E948A';
      const bg = isActive ? '#3F5D3A' : 'transparent';
      const fg = isActive ? '#FAF7F2' : color;
      const dotColor = isActive ? '#FAF7F2' : (filled ? '#3F5D3A' : '#C8C2B5');
      return `<button type="button" data-lang-chip="${l}" title="${LANG_LABELS[l]}${filled ? ' (dolu)' : ' (boş)'} — tıkla, bu dile geç" style="display:inline-flex; align-items:center; gap:4px; padding:3px 8px; margin-right:4px; border:1px solid ${color}; background:${bg}; color:${fg}; border-radius:12px; cursor:pointer; font:600 10px/1.2 Inter,sans-serif; letter-spacing:0.05em;">${l.toUpperCase()} <span style="color:${dotColor};">${filled ? '●' : '○'}</span></button>`;
    }).join('');
    return `
      <tr data-menu-row="${id}" style="border-bottom:1px solid #F0EBE0;">
        <td style="padding:8px 12px; vertical-align:top;">
          <div style="font-weight:600; color:#1F2420;">${isim}</div>
          <div style="font-size:11px; color:#8E948A;">${(p.kategori_clopos || '').replace(/</g, '&lt;')} · #${id}</div>
        </td>
        <td style="padding:8px 12px; vertical-align:top; color:#5C6359;">${fmtMoney(fiyat)} TL</td>
        <td style="padding:8px 12px; vertical-align:top;">
          <select data-field="kategori_grup" style="width:100%; padding:6px 8px; border:1px solid #E8E1D4; border-radius:4px; font:13px/1 Inter,sans-serif;">${opts}</select>
        </td>
        <td style="padding:8px 12px; vertical-align:top;">
          <textarea data-field="aciklama" data-lang="${lang}" rows="3" placeholder="${LANG_LABELS[lang]} açıklama…" style="width:100%; padding:6px 8px; border:1px solid #E8E1D4; border-radius:4px; font:13px/1.5 Inter,sans-serif; resize:vertical; white-space:pre-wrap;">${aciklama}</textarea>
          <div style="margin-top:6px;">${langChips}</div>
        </td>
        <td style="padding:8px 12px; vertical-align:top; text-align:center;">
          <input data-field="goster" type="checkbox" ${goster ? 'checked' : ''} style="width:18px; height:18px; cursor:pointer;">
        </td>
        <td style="padding:8px 12px; vertical-align:top; text-align:right;">
          <button data-action="save" title="Değişikliği panele kaydeder (4 dilin tüm taslak hali). Müşteri menüsüne yansıması için 'Şimdi yayına al' butonuna bas." style="background:#3F5D3A; color:#FAF7F2; border:none; padding:6px 12px; border-radius:4px; cursor:pointer; font-size:12px; font-weight:600;">Kaydet</button>
          <div data-row-status style="font-size:11px; color:#8E948A; margin-top:4px;"></div>
        </td>
      </tr>
    `;
  }

  async function saveMenuRow(cloposId, tr) {
    const statusEl = $('[data-row-status]', tr);
    const btn = $('[data-action="save"]', tr);
    btn.disabled = true; btn.textContent = '…';
    statusEl.textContent = '';

    const draft = getRowDraft(cloposId);
    const aciklamaEl = $('[data-field="aciklama"]', tr);
    // Şu an aktif olan dilin son hali textarea'da olabilir; draft'a yansıt.
    if (aciklamaEl) draft[draft.activeLang] = aciklamaEl.value;

    const payload = {
      kategori_grup: $('[data-field="kategori_grup"]', tr).value,
      goster: $('[data-field="goster"]', tr).checked ? 1 : 0,
      aciklama_tr: draft.tr,
      aciklama_en: draft.en,
      aciklama_es: draft.es,
      aciklama_ru: draft.ru
    };

    try {
      const token = getCookie(COOKIE_NAME) || '';
      const res = await fetch(`${WORKERS_URL}/products/${encodeURIComponent(cloposId)}?branch=${encodeURIComponent(state.branch)}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'X-Panel-Token': token },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.error || 'fail');
      // Local state'i güncelle (chip indikatörleri doğru görünsün)
      const idx = state.menuProducts.findIndex(p => String(p.clopos_id) === String(cloposId));
      if (idx >= 0) {
        Object.assign(state.menuProducts[idx], payload, { son_edit: new Date().toISOString() });
      }
      // Chip'lerin doluluk göstergesini güncellemek için satırı yeniden render et
      const fresh = document.createElement('tbody');
      fresh.innerHTML = menuRowHtml(state.menuProducts[idx] || {});
      const newTr = fresh.firstElementChild;
      tr.replaceWith(newTr);
      // Event handler'ları yeniden bağla
      $('[data-action="save"]', newTr).addEventListener('click', () => saveMenuRow(cloposId, newTr));
      const ta = $('[data-field="aciklama"]', newTr);
      if (ta) {
        ta.addEventListener('input', () => {
          const d = getRowDraft(cloposId);
          d[d.activeLang] = ta.value;
        });
      }
      $$('[data-lang-chip]', newTr).forEach(chip => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          switchRowLang(cloposId, chip.dataset.langChip, newTr);
        });
      });
      // FIX 2026-05-16: Auto-save listener'larını da rebind et (toggle + kategori)
      const newGoster = $('[data-field="goster"]', newTr);
      if (newGoster) newGoster.addEventListener('change', () => saveMenuRow(cloposId, newTr));
      const newKategori = $('[data-field="kategori_grup"]', newTr);
      if (newKategori) newKategori.addEventListener('change', () => saveMenuRow(cloposId, newTr));
      const newStatus = $('[data-row-status]', newTr);
      if (newStatus) {
        newStatus.textContent = '✓ Kaydedildi';
        newStatus.style.color = '#3F5D3A';
        setTimeout(() => { newStatus.textContent = ''; }, 3000);
      }
      return;
    } catch (e) {
      statusEl.textContent = 'Hata: ' + e.message;
      statusEl.style.color = '#A8463A';
    } finally {
      btn.disabled = false; btn.textContent = 'Kaydet';
    }
  }

  async function triggerSyncNow(container) {
    const btn = $('[data-menu-syncnow]', container);
    const statusEl = $('[data-menu-status]', container);
    if (!confirm('Şu anki menü ayarları Shopify\'a aktarılsın mı? ~80 ürün, ortalama 90 saniye sürer.')) return;
    btn.disabled = true;
    btn.textContent = 'Aktarılıyor…';
    statusEl.textContent = 'Shopify\'a aktarma başladı, lütfen bekle…';
    const t0 = Date.now();
    try {
      const data = await api('products_sync_now', { branch: state.branch });
      const dur = Math.round((Date.now() - t0) / 1000);
      const s = data || {};
      const errs = (s.errors || []).length;
      statusEl.innerHTML = `✓ Tamamlandı (${dur} sn) — ${s.upserted || 0} ürün güncel, ${s.drafted || 0} taslağa alındı, ${s.collection_assigned || 0} koleksiyon eklemesi${errs ? `, ${errs} hata` : ''}.`;
      statusEl.style.color = errs ? '#A8463A' : '#3F5D3A';
      // Yeni veriyi yenile
      await loadMenuProducts(container);
    } catch (e) {
      statusEl.textContent = 'Hata: ' + e.message;
      statusEl.style.color = '#A8463A';
    } finally {
      btn.disabled = false;
      btn.textContent = '⟳ Şimdi yayına al';
    }
  }

  async function triggerPollNow(container) {
    const btn = $('[data-menu-pollnow]', container);
    const statusEl = $('[data-menu-status]', container);
    btn.disabled = true;
    btn.textContent = 'Çekiliyor…';
    statusEl.textContent = 'Clopos\'tan anlık veri çekiliyor…';
    statusEl.style.color = '#5C6359';
    const t0 = Date.now();
    try {
      const data = await fetch(`${WORKERS_URL}/poll_now?branch=${encodeURIComponent(state.branch)}`, {
        method: 'POST',
        headers: { 'X-Panel-Token': getCookie(COOKIE_NAME) || '' }
      }).then(r => r.json());
      if (!data.ok) throw new Error(data.error || 'fail');
      const dur = Math.round((Date.now() - t0) / 1000);
      const s = data.data || {};
      statusEl.textContent = `✓ Çekildi (${dur} sn) — ${s.upserted || 0} adisyon güncellendi, ${s.skipped || 0} değişmemiş.`;
      statusEl.style.color = '#3F5D3A';
      // Ürün listesi de yenilensin (saatlik products sync ayrı, ama açıklamalar değişmiş olabilir)
      await loadMenuProducts(container);
    } catch (e) {
      statusEl.textContent = 'Hata: ' + e.message;
      statusEl.style.color = '#A8463A';
    } finally {
      btn.disabled = false;
      btn.textContent = '↻ Clopos\'tan anlık çek';
    }
  }

  // ============================================================
  // === MENÜ ÖZEL ALANLAR — custom_fields paneli (4-dil grid)
  // ============================================================

  state.customFieldsInited = false;
  state.cfData = null;        // { fields:[...], values:{tr:{},en:{},es:{},ru:{}} }
  state.cfDrafts = {};        // { 'key|lang': 'value' } — kaydedilmemiş değişiklikler

  const CF_LANGS = [
    { code: 'tr', label: 'Türkçe' },
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'ru', label: 'Русский' }
  ];

  const CF_GROUP_LABELS = {
    welcome: 'Karşılama (Sayfa Üstü)',
    category_headers: 'Kategori Başlıkları',
    dondurma_pricing: 'Dondurma Top Fiyatları',
    dondurma_groups: 'Dondurma Grupları (Başlık + Çeşitler)',
    info_messages: 'Kategori Bilgi Mesajları',
    allergen: 'Alerjen Uyarısı (Sayfa Altı)'
  };

  async function initCustomFieldsTab() {
    state.customFieldsInited = true;
    const container = $('[data-vita-tabpanel="customfields"]');
    if (!container) return;
    container.innerHTML = `
      <div class="vita-cf" style="padding:24px; max-width:1400px; margin:0 auto;">
        <div style="display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:16px; flex-wrap:wrap;">
          <div style="flex:1; min-width:280px;">
            <h2 style="font-family: Fraunces, Georgia, serif; font-weight: 500; color: #3F5D3A; margin: 0 0 4px;">Menü Özel Alanlar</h2>
            <p style="color:#5C6359; margin:0; font-size:13px; line-height:1.5;">Menü sayfasındaki <strong>fiyat, başlık ve bilgi metinlerini</strong> 4 dilde düzenleyin. <strong>Kaydet</strong> = panele yazar; menü sayfası her açıldığında bu değerleri canlı çeker, ayrıca yayına alma adımı YOKTUR.</p>
          </div>
          <div style="display:flex; gap:8px; align-items:center;">
            <button data-cf-reload style="background:#FFF; color:#3F5D3A; border:1px solid #3F5D3A; padding:9px 14px; border-radius:6px; cursor:pointer; font-weight:600; font-size:13px;">↻ Yenile</button>
            <button data-cf-saveall style="background:#3F5D3A; color:#FAF7F2; border:none; padding:10px 18px; border-radius:6px; cursor:pointer; font-weight:600; font-size:13px;">💾 Değişiklikleri Kaydet</button>
          </div>
        </div>
        <div data-cf-status style="margin-bottom:12px; font-size:13px; color:#5C6359;">Yükleniyor…</div>
        <div data-cf-body></div>
      </div>
    `;
    $('[data-cf-reload]', container).addEventListener('click', () => loadCustomFields(container, true));
    $('[data-cf-saveall]', container).addEventListener('click', () => saveCustomFields(container));
    await loadCustomFields(container);
  }

  async function loadCustomFields(container, force) {
    const status = $('[data-cf-status]', container);
    status.textContent = 'Yükleniyor…';
    try {
      const data = await api('custom_fields_list', { branch: state.branch });
      state.cfData = data;
      state.cfDrafts = {};
      renderCustomFields(container);
      status.textContent = `${(data.fields || []).length} alan · 4 dil. Değişiklik yaparsanız "Kaydet" butonuna basın.`;
      status.style.color = '#5C6359';
    } catch (e) {
      status.textContent = 'Hata: ' + e.message;
      status.style.color = '#A8463A';
    }
  }

  function renderCustomFields(container) {
    const body = $('[data-cf-body]', container);
    if (!state.cfData || !state.cfData.fields) {
      body.innerHTML = '<div style="padding:24px; text-align:center; color:#8E948A;">Veri yok.</div>';
      return;
    }
    // Group fields
    const byGroup = {};
    for (const f of state.cfData.fields) {
      const g = f.group_name || 'other';
      if (!byGroup[g]) byGroup[g] = [];
      byGroup[g].push(f);
    }
    const orderedGroups = Object.keys(CF_GROUP_LABELS).filter(g => byGroup[g]);
    for (const g of Object.keys(byGroup)) if (!orderedGroups.includes(g)) orderedGroups.push(g);

    let html = '';
    for (const g of orderedGroups) {
      const fields = byGroup[g].sort((a, b) => a.ord - b.ord);
      html += `
        <details open style="margin-bottom:16px; background:#FFF; border:1px solid #E8E1D4; border-radius:8px;">
          <summary style="padding:14px 18px; font-family:Fraunces,Georgia,serif; font-size:18px; color:#3F5D3A; cursor:pointer; user-select:none; border-bottom:1px solid #E8E1D4; background:#FAF7F2; border-radius:8px 8px 0 0;">
            ${CF_GROUP_LABELS[g] || g} <span style="font-family:Inter,sans-serif; font-size:12px; color:#8E948A; font-weight:400; margin-left:8px;">(${fields.length} alan)</span>
          </summary>
          <div style="padding:8px 14px 14px;">
            ${fields.map(f => cfFieldRow(f)).join('')}
          </div>
        </details>
      `;
    }
    body.innerHTML = html;

    // bind input listeners (track drafts)
    $$('[data-cf-input]', body).forEach(inp => {
      inp.addEventListener('input', () => {
        const k = inp.dataset.cfKey;
        const l = inp.dataset.cfLang;
        const initial = inp.dataset.cfInitial || '';
        const id = `${k}|${l}`;
        if (inp.value === initial) {
          delete state.cfDrafts[id];
          inp.style.borderColor = '#E8E1D4';
        } else {
          state.cfDrafts[id] = inp.value;
          inp.style.borderColor = '#C4884E';
        }
        updateCfSaveBadge(container);
      });
    });
    updateCfSaveBadge(container);
  }

  function cfFieldRow(f) {
    const isTextarea = f.type === 'textarea';
    const vals = state.cfData.values || {};
    let langCols = '';
    for (const L of CF_LANGS) {
      const v = (vals[L.code] && vals[L.code][f.key]) || '';
      const safe = (v + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      const safeAttr = (v + '').replace(/"/g, '&quot;');
      if (isTextarea) {
        langCols += `
          <div style="display:flex; flex-direction:column; gap:4px;">
            <label style="font-size:10px; letter-spacing:0.1em; color:#8E948A; text-transform:uppercase; font-weight:500;">${L.label} <span style="color:#C4884E;">(${L.code})</span></label>
            <textarea data-cf-input data-cf-key="${f.key}" data-cf-lang="${L.code}" data-cf-initial="${safeAttr}" rows="3" style="resize:vertical; padding:8px 10px; border:1px solid #E8E1D4; border-radius:4px; font:13px/1.4 Inter,sans-serif; color:#1F2420; background:#FAF7F2; min-height:60px;">${safe}</textarea>
          </div>`;
      } else {
        langCols += `
          <div style="display:flex; flex-direction:column; gap:4px;">
            <label style="font-size:10px; letter-spacing:0.1em; color:#8E948A; text-transform:uppercase; font-weight:500;">${L.label} <span style="color:#C4884E;">(${L.code})</span></label>
            <input type="text" data-cf-input data-cf-key="${f.key}" data-cf-lang="${L.code}" data-cf-initial="${safeAttr}" value="${safeAttr}" style="padding:8px 10px; border:1px solid #E8E1D4; border-radius:4px; font:13px/1 Inter,sans-serif; color:#1F2420; background:#FAF7F2;">
          </div>`;
      }
    }
    return `
      <div style="padding:10px 0; border-bottom:1px solid #F4EDDF;">
        <div style="font-weight:600; font-size:13px; color:#1F2420; margin-bottom:6px;">${escapeHtml(f.label || f.key)} <code style="font-size:11px; color:#8E948A; font-weight:400; margin-left:6px;">${f.key}</code></div>
        <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap:10px;">
          ${langCols}
        </div>
      </div>
    `;
  }

  function escapeHtml(s) {
    return (s + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function updateCfSaveBadge(container) {
    const btn = $('[data-cf-saveall]', container);
    const n = Object.keys(state.cfDrafts).length;
    btn.textContent = n ? `💾 ${n} Değişikliği Kaydet` : '💾 Değişiklikleri Kaydet';
    btn.style.opacity = n ? '1' : '0.6';
  }

  async function saveCustomFields(container) {
    const updates = Object.entries(state.cfDrafts).map(([id, value]) => {
      const [key, lang] = id.split('|');
      return { key, lang, value };
    });
    if (!updates.length) {
      const status = $('[data-cf-status]', container);
      status.textContent = 'Değişiklik yok.';
      return;
    }
    const status = $('[data-cf-status]', container);
    const btn = $('[data-cf-saveall]', container);
    status.textContent = `${updates.length} alan kaydediliyor…`;
    status.style.color = '#5C6359';
    btn.disabled = true;
    try {
      const res = await api('custom_fields_patch', { branch: state.branch }, { body: { branch: state.branch, updates } });
      if (!res.ok) throw new Error(res.error || 'kaydetme başarısız');
      status.textContent = `✓ ${res.changed || updates.length} alan kaydedildi. Menü sayfasını yenileyince yansır.`;
      status.style.color = '#3F5D3A';
      await loadCustomFields(container);
    } catch (e) {
      status.textContent = 'Hata: ' + e.message;
      status.style.color = '#A8463A';
    } finally {
      btn.disabled = false;
    }
  }

})();
